module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }, [_c('h1', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")])]), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/e9780545794695_title001#tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ded001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/e9780545794695_ch001"
    }
  }, [_vm._v("“It’s Always Us!”")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fish’s Decree")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cannon at Midnight")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assignment: Obnoxious!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Keep "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ants")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Round Two")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desperate Measures")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raid!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch009",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Expelled?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast at Scrimmage’s")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Congratulations, Boys”")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Help!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scrimmage’s to the Rescue")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No End to Miracles!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_ata001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_bm001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q&A with Gordon Korman")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_fm001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545794695_copy001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227425b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545794695_toc001.vue
// module id = 63
// module chunks = 0